module.exports = __webpack_public_path__ + "static/15-3-6f0a172bf8403d98f902061f0deecdd4.jpg";